/**
 * Given a coordinate count and a threshold→budget mapping, returns the
 * appropriate max-points budget for downsampling.
 *
 * Thresholds are sorted ascending; the first threshold ≥ coordCount wins.
 * If coordCount exceeds every threshold, the largest budget is returned.
 */
export const getDownsamplingBudget = (
  coordCount: number,
  thresholdMap: Record<number, number>,
): number => {
  const sorted = Object.keys(thresholdMap)
    .map(Number)
    .sort((a, b) => a - b)

  for (const threshold of sorted) {
    if (coordCount <= threshold) return thresholdMap[threshold]
  }

  // Exceeds all thresholds – use the largest budget
  return thresholdMap[sorted[sorted.length - 1]]
}

